module.exports = __webpack_public_path__ + "img/lgjcjkzxt.0132ec15.jpg";